import React, { useState, useEffect } from 'react';
import  { useNavigate, useLocation } from 'react-router-dom'

import imgThaivy from '../images/helpsuccess/thaivy.png'  

function HelpSuccessPage() {

  const navigate = useNavigate();
  const { state } = useLocation()
  const [ goPath, setGoPath ] = useState('/')

  useEffect(() => {
    if(state?.goPath){
      setGoPath(state.goPath)
    }
  }, [])

  function gotoPage(){
    navigate(goPath, { replace: true })
  }

  return (
  <div className="flex-wrap w-full  h-full min-h-screen   md:px-[120px] font-prompt py-4 px-2 ">
      <div className="flex w-full  flex-wrap  justify-center pb-12  h-screen flex items-center justify-center">
        <div className="flex flex-wrap w-full  lg:w-[974px]   bg-white rounded-xl ">
          <div className='flex-wrap flex w-full'>
            <div className=" flex-wrap w-full   p-6 md:py-6   px-4 md:px-6  flex justify-center  ">
              <div className='flex w-full justify-center'>
                <img src={imgThaivy} alt="icon-success" className='w-[180px] h-[150px]' />
              </div>
              <div className='flex flex-wrap w-full  justify-center'>
                <span className='w-full mt-[24px] text-[16px] font-medium  text-black  text-center  '>ส่งข้อมูลสำเร็จ</span>
                <span className='w-full mt-[4px] text-[14px] text-[#666] font-normal leading-5 text-center text-black '>ทางบริษัทฯ ได้รับข้อมูลของคุณเรียบร้อยแล้ว <br/>และจะติดต่อกลับหาคุณโดยเร็วที่สุด</span>
                <button 
                      onClick={gotoPage} 
                      className={'w-[400px] mt-[30px] lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-lg border-radius-other  bg-green-500 text-white '}>
                        กลับสู่หน้าหลัก
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  )
}

export default HelpSuccessPage;